import React, { useState, useEffect, useRef, useContext } from 'react';
import { useForm } from 'react-hook-form';
import AlertContext from '../../../GlobalComponents/Alert/contexts/alertContext';

//import global components
import { Card, Modal, ModalActionConfirm } from '../../../../imports';

//import services
import { ObtenerCategoriaExperiencia, EditarExperiencia, AgregarExperienciaIndividual, EliminarExperiencia } from '../../../../servicios/ServicioExperiencia';

//import icons from heroicons
import { PlusCircleIcon, UserIcon, DocumentTextIcon, XMarkIcon, CheckCircleIcon, BriefcaseIcon, CalendarIcon } from '@heroicons/react/24/outline';

export default function Experiencia({
    validationMessages,
    userData,
    setUserData,
    finalData,
    setstateExperiencia,
    allowEdit,
    listExperienceByPerson,
    setListExperienceByPerson,
    experienceDataEdit,
    setExperienceDataEdit,
    isFirstLoadExperience,
    setIsFirstLoadExperience,
    idCurriculum
}) {

    //use alert context
    const alertCtx = useContext(AlertContext);

    //here we pass a default input property to save in userData
    //all inputs use this same event in 'onchange'
    const handleChange = (e) => {
        const { name, value } = e.target;
        setValue(name, e.target.value)
    };

    //use react hook form to get values and make validations
    const { register, reset, getValues, setValue, handleSubmit, formState } = useForm({
        mode: 'all',
        defaultValues: {
            nameCompany: '',
            positionHeld: '',
            startDate: '',
            finishDate: '',
            functionsPerformed: '',
            experienceCategory: ''
        }
    });

    const modalStyle = {
        background: 'transparent',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        margin: 0
    };

    const { errors } = formState;

    //use to get validations from props and later iterate
    const [validations, setValidations] = useState([]);

    const [showModal, setShowModal] = useState(false);

    //flag to point into box selected 
    const [detectCheckBox, setDetect] = useState(false);

    const [OnWork, setWork] = useState(false);

    const [listExperience, setListExperience] = useState([]);

    const [currentIdCard, setCurrentIdCard] = useState(null);

    //use to get experience options
    const [experienceOptions, setExperienceOptions] = useState([]);

    //use modal and show for save
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [actionTypeConfirmModal, setActionTypeConfirmModal] = useState("");
    const [showConfirmEditModal, setShowConfirmEditModal] = useState(false);

    const [idFromCard, setIdFromCard] = useState(0);

    //validate if user already complete cv
    const userCompleteCV = sessionStorage.getItem("USER_COMPLETE_CV");

    const [userSaveActionSuccess, setUserSaveActionSuccess] = useState(false);

    const [dataIndividualExperience, setDataIndividualExperience] = useState({});

    //use to change and detect checkbox
    const detectCheck = event => {
        event.preventDefault();
        const newValue = !OnWork;
        setWork(newValue);
        setDetect(newValue);
        setValue("currentlyWorking", newValue);
        if (newValue === false) {
            resetinputs();
        }
    }

    async function getExperienceType() {
        const response = await ObtenerCategoriaExperiencia();
        if (response !== undefined) {
            setExperienceOptions(response);
        }
    }

    const resetinputs = () => {
        setValue("finishDate", "");
    }

    //call services to delete elements from education
    async function EliminarExperienciaPersona(idProyecto) {
        const response = await EliminarExperiencia(idProyecto);
        return response;
    }

    //method to add new project
    const AgregarExperienciaPersona = async (e) => {
        const ExperienciaData = {
            nombreEmpresa: dataIndividualExperience.dataForGlobalList?.nameCompany,
            puestoDesempenado: dataIndividualExperience.dataForGlobalList?.positionHeld,
            fechaIngreso: dataIndividualExperience.dataForGlobalList?.startDate === "" ? null : dataIndividualExperience.dataForGlobalList?.startDate,
            fechaSalida: dataIndividualExperience.dataForGlobalList?.finishDate === "" ? null : dataIndividualExperience.dataForGlobalList?.finishDate,
            trabajando: dataIndividualExperience.dataForGlobalList?.currentlyWorking,
            funcionesRealizadas: dataIndividualExperience.dataForGlobalList?.functionsPerformed,
            idPersona: idCurriculum,
            idCategoriaExperiencia: parseInt(dataIndividualExperience.dataForGlobalList?.categoryExperience, 10)
        }

        const experienciaResponse = await AgregarExperienciaIndividual(ExperienciaData);

        if (experienciaResponse.indicador === 0) {
            if (currentIdCard) {
                if (listExperience?.length > currentIdCard - 1 && listExperience[currentIdCard] !== undefined) {
                    for (let item of Object.keys(listExperience)) {
                        if (listExperience[item] === listExperience[currentIdCard]) {
                            listExperience[item] = dataIndividualExperience
                        }
                    }
                }
            } else {
                setListExperience([...listExperience, dataIndividualExperience])
            }

            alertCtx.success(experienciaResponse.mensaje);
            setUserSaveActionSuccess(true);
            setShowConfirmSaveModal(false);
            setDetect(false);
            setDataIndividualExperience({});
            setCurrentIdCard(null);
            setShowModal(false);
        }
    }

    //method to edit project from person by id
    const EditarExperienciaPersona = async (e) => {
        const ExperienciaData = {
            idExperiencia: dataIndividualExperience.dataForGlobalList?.idExperience,
            nombreEmpresa: dataIndividualExperience.dataForGlobalList?.nameCompany,
            puestoDesempenado: dataIndividualExperience.dataForGlobalList?.positionHeld,
            fechaIngreso: dataIndividualExperience.dataForGlobalList?.startDate === "" ? null : dataIndividualExperience.dataForGlobalList?.startDate,
            fechaSalida: dataIndividualExperience.dataForGlobalList?.finishDate === "" ? null : dataIndividualExperience.dataForGlobalList?.finishDate,
            trabajando: dataIndividualExperience.dataForGlobalList?.currentlyWorking,
            funcionesRealizadas: dataIndividualExperience.dataForGlobalList?.functionsPerformed,
            idCategoriaExperiencia: parseInt(dataIndividualExperience.dataForGlobalList?.categoryExperience, 10),
            idPersona: idCurriculum
        }

        const experienciaResponse = await EditarExperiencia(ExperienciaData);

        if (experienciaResponse.indicador === 0) {
            if (currentIdCard) {
                if (listExperience?.length > currentIdCard - 1 && listExperience[currentIdCard] !== undefined) {
                    for (let item of Object.keys(listExperience)) {
                        if (listExperience[item] === listExperience[currentIdCard]) {
                            listExperience[item] = dataIndividualExperience
                        }
                    }
                }
            } else {
                setListExperience([...listExperience, dataIndividualExperience])
            }

            alertCtx.success(experienciaResponse.mensaje);
            setUserSaveActionSuccess(true);
            setShowConfirmEditModal(false);
            setDetect(false);
            setDataIndividualExperience({});
            setCurrentIdCard(null);
            setShowModal(false);
        }
    }

    //function to save 'experience' in list
    const SaveExperienceOptions = () => {
        const startDate = getValues("startDate");
        const finishDate = getValues("finishDate");
        const nameCompany = getValues("nameCompany");
        const positionHeld = getValues("positionHeld");
        const functionsPerformed = getValues("functionsPerformed");
        const experienceCategory = getValues("experienceCategory");

        // Validar campos requeridos manualmente
        if (!nameCompany || !positionHeld || !functionsPerformed || !experienceCategory) {
            alertCtx.error("Por favor complete todos los campos requeridos");
            return;
        }

        if (startDate === "" && finishDate === "" && OnWork === false) {
            alertCtx.error("Por favor ingrese las fechas");
            return;
        } else if (startDate > finishDate && OnWork === false && finishDate !== "") {
            alertCtx.error("La fecha de finalización debe ser mayor a la fecha de inicio");
            return;
        } else {
            const nameCompany = getValues("nameCompany");
            const categoryExperience = getValues("experienceCategory");
            const positionHeld = getValues("positionHeld");
            const currentlyWorking = OnWork;
            const startDate = getValues("startDate");
            const finishDate = OnWork === true ? "" : getValues("finishDate");
            const functionsPerformed = getValues("functionsPerformed");

            const dataForGlobalList = {
                nameCompany: nameCompany,
                categoryExperience: parseInt(categoryExperience, 10),
                positionHeld: positionHeld,
                currentlyWorking: currentlyWorking,
                startDate: startDate,
                finishDate: finishDate,
                functionsPerformed: functionsPerformed,
                idExperience: idFromCard
            }

            const object = {
                "dataHeader": {
                    "Empresa": nameCompany,
                    "Puesto Desempeñado": positionHeld,
                },
                "dataBody": {
                    "Fecha ingreso": startDate,
                    "Fecha salida": finishDate,
                },
                "dataFooter": {
                    "Trabaja actualmente": currentlyWorking ? "Si" : "No"
                },
                "dataID": {
                    "idExperiencia": idFromCard
                },
                "dataForGlobalList": dataForGlobalList
            }

            if (userCompleteCV === "true") {
                setDataIndividualExperience(object);
                if (actionTypeConfirmModal === "Agregar") setShowConfirmSaveModal(true);
                if (actionTypeConfirmModal === "Editar") setShowConfirmEditModal(true);
                resetAllInputs();
            } else {
                if (currentIdCard) {
                    if (listExperience?.length > currentIdCard - 1 && listExperience[currentIdCard] !== undefined) {
                        for (let item of Object.keys(listExperience)) {
                            if (listExperience[item] === listExperience[currentIdCard]) {
                                listExperience[item] = object
                            }
                        }
                    }
                } else {
                    setListExperience([...listExperience, object])
                }
                resetAllInputs();
                setCurrentIdCard(null);
                setShowModal(false);
                alertCtx.success("Datos guardados temporalmente");
                setIdFromCard(0);
            }
        }
    }

    const resetAllInputs = () => {
        reset({
            nameCompany: "",
            experienceCategory: "",
            positionHeld: "",
            currentlyWorking: "",
            startDate: "",
            finishDate: "",
            functionsPerformed: ""
        }, {
            keepErrors: false,
            keepDirty: false,
        })
        setDetect(false);
        setWork(false);
    }

    function setValuesById(list) {
        if (!list || !list.dataForGlobalList) return;

        setValue("nameCompany", list.dataForGlobalList?.nameCompany || "")
        setValue("experienceCategory", list.dataForGlobalList?.categoryExperience || "")
        setValue("positionHeld", list.dataForGlobalList?.positionHeld || "")
        setValue("startDate", list.dataForGlobalList?.startDate || "")
        setValue("finishDate", list.dataForGlobalList?.finishDate || "")
        setValue("functionsPerformed", list.dataForGlobalList?.functionsPerformed || "")

        const currentlyWorkingValue = list.dataForGlobalList?.currentlyWorking === true || list.dataForGlobalList?.currentlyWorking === "true";

        setDetect(currentlyWorkingValue);
        setWork(currentlyWorkingValue);
        setValue("currentlyWorking", currentlyWorkingValue);
        setIdFromCard(list?.dataID?.idExperiencia || 0);
    }

    //create custom object with list by person id to render cards
    function customObjectByPersonList() {
        listExperienceByPerson.map((item) => {
            const startMonth = new Date(item?.fechaIngreso).getMonth() + 1;
            const startYear = new Date(item?.fechaIngreso).getFullYear();
            const startDay = new Date(item?.fechaIngreso).getDay();
            const startDateFormatted = `${startYear}-${startMonth}-${startDay}`;
            const startDate = new Date(startDateFormatted)

            const endMonth = new Date(item?.fechaSalida).getMonth() + 1;
            const endYear = new Date(item?.fechaSalida).getFullYear();
            const endDay = new Date(item?.fechaSalida).getDay();
            const endDateFormatted = `${endYear}-${endMonth}-${endDay}`;
            const endDate = new Date(endDateFormatted)

            const dataForGlobalList = {
                nameCompany: item?.nombreEmpresa,
                categoryExperience: item?.idCategoriaExperiencia,
                positionHeld: item?.puestoDesempenado,
                currentlyWorking: item?.trabajando,
                startDate: item?.fechaIngreso ? startDate.toLocaleDateString('fr-CA') : "",
                finishDate: item?.fechaSalida ? endDate.toLocaleDateString('fr-CA') : "",
                functionsPerformed: item?.funcionesRealizadas,
                idExperience: item?.idExperiencia
            }

            const object = {
                "dataHeader": {
                    "Empresa": item?.nombreEmpresa,
                    "Puesto Desempeñado": item?.puestoDesempenado,
                },
                "dataBody": {
                    "Fecha ingreso": item?.fechaIngreso ? startDate.toLocaleDateString('fr-CA') : "",
                    "Fecha salida": item?.fechaSalida ? endDate.toLocaleDateString('fr-CA') : "",
                },
                "dataFooter": {
                    "Trabaja actualmente": item?.trabajando ? "Si" : "No"
                },
                "dataID": {
                    "idExperiencia": item?.idExperiencia
                },
                "dataForGlobalList": dataForGlobalList
            }

            if (listExperience !== undefined) {
                listExperience.push(object);
            }
        })
    }

    useState(() => {
        getExperienceType();
        setValidations(validationMessages);
        setDetect(false);
        setWork(false);
    }, [])

    useEffect(() => {
        if (userCompleteCV === "true" && isFirstLoadExperience || allowEdit === true && isFirstLoadExperience) {
            if (listExperienceByPerson?.length > 0) {
                customObjectByPersonList();
                if (isFirstLoadExperience) setIsFirstLoadExperience(false)
            }
        }

        if (userCompleteCV === "true" || allowEdit === true) {
            if (listExperience?.length > 0) {
                if (experienceDataEdit) {
                    setExperienceDataEdit(listExperience);
                }
            } else {
                if (experienceDataEdit) {
                    setListExperience(experienceDataEdit);
                }
            }
        } else {
            if (listExperience?.length > 0) {
                setstateExperiencia(true);
                if (userData) {
                    setUserData({ ...userData, "listExperience": listExperience })
                }
            } else {
                setstateExperiencia(false);
                if (userData["listExperience"]) {
                    setListExperience(userData["listExperience"])
                }
            }
        }

        if (userCompleteCV === "true" && !showModal || allowEdit === true && !showModal) {
            const timeout = setTimeout(() => {
                if (experienceDataEdit) {
                    setExperienceDataEdit(listExperience);
                }
            }, 1000);
            return () => clearTimeout(timeout);
        } else if (!showModal) {
            const timeout = setTimeout(() => {
                if (listExperience) {
                    if (userData) {
                        setUserData({ ...userData, "listExperience": listExperience });
                    }
                }
            }, 1000);
            return () => clearTimeout(timeout);
        }

        return (() => {
            if (userCompleteCV === "true" || allowEdit === true) {
                if (isFirstLoadExperience) {
                    setIsFirstLoadExperience(false);
                }
                if (experienceDataEdit) {
                    setExperienceDataEdit(listExperience);
                }
            } else {
                if (listExperience) {
                    setUserData({ ...userData, "listExperience": listExperience });
                }
            }
            setShowModal(false);
        })
    }, [showModal, listExperience, userSaveActionSuccess, dataIndividualExperience, actionTypeConfirmModal])

    return (
        <div className="w-full flex flex-col md:flex-row items-center justify-center px-1 mx-auto lg:py-0">
            <div className={userCompleteCV === "false" ? "w-full pt-1 bg-white rounded-lg shadow" : "w-full pt-1"}>
                <div className="relative container mx-auto items-center justify-center">
                    {listExperience?.length === 0 && userCompleteCV === "true" && !allowEdit && (
                        <div className="flex justify-center items-center mb-4 px-2 space-x-2">
                            <div className="flex-shrink-0">
                                <BriefcaseIcon className="h-8 w-8 mr-2 text-red-RS" />
                            </div>
                            <div>
                                <h1 className="font-bold font-base">Esta información es requerida para tomar en cuenta su Curriculum Vitae</h1>
                            </div>
                        </div>
                    )}

                    {!allowEdit && listExperience?.length === 0 && (
                        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                            <h1 className="text-decoration-line: underline">Por favor, presione Agregar para completar el apartado de experiencia</h1>
                        </div>
                    )}

                    {/* ADMINISTRADOR - Usar el mismo estilo de Card que el usuario */}
                    {allowEdit && listExperience?.length > 0 && (
                        <div className="container flex flex-wrap w-full py-4 mt-0 mx-auto items-start justify-center">
                            {listExperience?.map((item, index) => (
                                <div className="w-full m-0 mt-2 p-1 py-6 md:w-96" key={index}>
                                    <Card
                                        id={index}
                                        data={item}
                                        list={listExperience}
                                        setList={setListExperience}
                                        setCurrentIdCard={setCurrentIdCard}
                                        setShowModal={setShowModal}
                                        setValuesById={setValuesById}
                                        allowEdit={allowEdit}
                                        listByPerson={listExperienceByPerson}
                                        setListExperienceByPerson={setListExperienceByPerson}
                                        userCompleteCV={userCompleteCV}
                                        deleteElementCV={EliminarExperienciaPersona}
                                        setActionTypeConfirmModal={setActionTypeConfirmModal}
                                        title="Experiencia"
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    {/* USUARIO - Mostrar tarjetas con opciones de edición */}
                    {!allowEdit && listExperience?.length > 0 && (
                        <div className="container flex flex-wrap w-full py-4 mt-6 mx-auto items-start justify-center">
                            {listExperience?.map((item, index) => (
                                <div className="w-full m-1 mt-8 p-1 py-6 md:w-96" key={index}>
                                    <Card
                                        id={index}
                                        data={item}
                                        list={listExperience}
                                        setList={setListExperience}
                                        setCurrentIdCard={setCurrentIdCard}
                                        setShowModal={setShowModal}
                                        setValuesById={setValuesById}
                                        allowEdit={allowEdit}
                                        listByPerson={listExperienceByPerson}
                                        setListExperienceByPerson={setListExperienceByPerson}
                                        userCompleteCV={userCompleteCV}
                                        deleteElementCV={EliminarExperienciaPersona}
                                        setActionTypeConfirmModal={setActionTypeConfirmModal}
                                        title="Experiencia"
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    {/* BOTÓN AGREGAR - Solo visible en modo usuario (no admin) */}
                    {!allowEdit && (
                        <div>
                            {listExperience?.length > 0 ? (
                                <div className="flex absolute top-0 right-0 md:justify-center items-center mb-8 px-2 py-6">
                                    <button
                                        className="bg-greenButton hover:bg-primary-700 text-white text-sm py-2 px-4 rounded inline-flex items-center"
                                        onClick={() => {
                                            resetAllInputs();
                                            setShowModal(true);
                                            setActionTypeConfirmModal("Agregar");
                                        }}
                                    >
                                        <span>Agregar</span>
                                        <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                                    </button>
                                </div>
                            ) : (
                                <div className="flex justify-center items-center mb-4 px-2 py-2">
                                    <button
                                        className="bg-greenButton hover:bg-primary-700 text-white text-sm py-2 px-4 rounded inline-flex items-center"
                                        onClick={() => {
                                            resetAllInputs();
                                            setShowModal(true);
                                            setActionTypeConfirmModal("Agregar");
                                        }}
                                    >
                                        <span>Agregar</span>
                                        <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                                    </button>
                                </div>
                            )}
                        </div>
                    )}

                    {/* MODALES DE CONFIRMACIÓN */}
                    <Modal isVisible={showConfirmSaveModal} onClose={() => { setShowConfirmSaveModal(false) }} handleSubmit={() => null} onSaveOptions={null} showFotter={false} showCloseIcon={false}>
                        <ModalActionConfirm onSaveAction={AgregarExperienciaPersona} actionType={actionTypeConfirmModal} setshowConfirmModal={setShowConfirmSaveModal} />
                    </Modal>

                    <Modal isVisible={showConfirmEditModal} onClose={() => { setShowConfirmEditModal(false) }} handleSubmit={() => null} onSaveOptions={null} showFotter={false} showCloseIcon={false}>
                        <ModalActionConfirm onSaveAction={EditarExperienciaPersona} actionType={actionTypeConfirmModal} setshowConfirmModal={setShowConfirmEditModal} />
                    </Modal>

                    {/* MODAL DE EXPERIENCIA - Solo visible en modo usuario */}
                    {!allowEdit && (
                        <Modal
                            isVisible={showModal}
                            onClose={() => { setShowModal(false); resetAllInputs(); }}
                            onSaveOptions={SaveExperienceOptions}
                            showFotter={false}
                            showCloseIcon={false}
                            insideContainer={{ className: "bg-transparent", style: modalStyle }}
                        >
                            <div className="bg-white rounded-3xl p-8 border border-gray-200/80 shadow-xl shadow-gray-200/30 w-full max-w-4xl mx-auto">
                                {/* Cabecera del modal */}
                                <div className="flex justify-between items-center mb-8 pb-4 relative">
                                    <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-[#B93C2F] via-[#D37267] to-transparent"></div>
                                    <div className="absolute bottom-0 left-0 w-1/3 h-1 bg-[#B93C2F] blur-sm opacity-50"></div>

                                    <div className="flex items-center gap-3">
                                        <div className="relative">
                                            <div className="absolute -inset-2 bg-gradient-to-r from-[#B93C2F] to-[#D37267] rounded-2xl opacity-20 blur-sm"></div>
                                            <div className="absolute -inset-1 border-2 border-[#B93C2F]/20 rounded-2xl"></div>
                                            <div className="relative bg-[#FFE5E1] p-3 rounded-2xl text-[#B93C2F] shadow-lg shadow-red-500/20">
                                                <BriefcaseIcon className="h-7 w-7" />
                                            </div>
                                        </div>
                                        <div className="relative">
                                            <h2 className="text-2xl font-extrabold text-[#3C2E2C] tracking-tight">Experiencia</h2>
                                            <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-[#B93C2F] to-transparent"></div>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => { setShowModal(false); resetAllInputs(); }}
                                        className="p-2 rounded-xl hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-all duration-300 hover:rotate-90"
                                    >
                                        <XMarkIcon className="h-5 w-5" />
                                    </button>
                                </div>

                                <form onSubmit={(e) => { e.preventDefault(); SaveExperienceOptions(); }} className="space-y-5">
                                    {/* Nombre de la Empresa y Tipo de Experiencia en 2 columnas */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="flex flex-col space-y-1.5">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                Nombre de la empresa
                                            </label>
                                            <div className="relative group">
                                                <input
                                                    type="text"
                                                    name="nameCompany"
                                                    {...register("nameCompany", { required: true, maxLength: 150 })}
                                                    id="nameCompany"
                                                    placeholder="Nombre de la empresa"
                                                    className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 hover:border-gray-300 pr-12"
                                                />
                                                <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-300 group-hover:text-[#B93C2F] transition-colors duration-300">
                                                    <UserIcon className="h-5 w-5" />
                                                </div>
                                            </div>
                                            {validations.nameCompany?.map((values) => (
                                                errors.nameCompany?.type === values.type &&
                                                <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                            ))}
                                        </div>

                                        <div className="flex flex-col space-y-1.5">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                Tipo de experiencia
                                            </label>
                                            <select
                                                id="experienceCategory"
                                                {...register('experienceCategory', { required: true })}
                                                className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 appearance-none cursor-pointer hover:border-gray-300"
                                                name="experienceCategory"
                                            >
                                                <option value="">--Seleccione la categoría--</option>
                                                {experienceOptions.map((option, index) => (
                                                    <option key={index} value={option.idCategoriaExperiencia}>{option.tipoExperiencia}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Puesto Desempeñado y Fechas en 2 columnas */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="flex flex-col space-y-1.5">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                Puesto desempeñado
                                            </label>
                                            <div className="relative group">
                                                <input
                                                    type="text"
                                                    name="positionHeld"
                                                    {...register("positionHeld", { required: true, maxLength: 30, pattern: /^[a-zA-ZñÑ\s\W]/ })}
                                                    id="positionHeld"
                                                    placeholder="Puesto desempeñado"
                                                    className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 hover:border-gray-300 pr-12"
                                                />
                                                <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-300 group-hover:text-[#B93C2F] transition-colors duration-300">
                                                    <UserIcon className="h-5 w-5" />
                                                </div>
                                            </div>
                                            {validations.positionHeld?.map((values) => (
                                                errors.positionHeld?.type === values.type &&
                                                <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                            ))}
                                        </div>

                                        <div className="flex flex-col space-y-1.5">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                Fecha ingreso
                                            </label>
                                            <input
                                                type="date"
                                                name="startDate"
                                                {...register("startDate", { required: true })}
                                                id="startDate"
                                                className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 cursor-pointer hover:border-gray-300"
                                            />
                                            {validations.startDate?.map((values) => (
                                                errors.startDate?.type === values.type &&
                                                <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                            ))}
                                        </div>
                                    </div>

                                    {/* ¿Trabaja actualmente? y Fecha salida en 2 columnas */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
                                        <div className="flex flex-col space-y-2">
                                            <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                ¿Trabaja actualmente?
                                            </label>
                                            <div className="flex items-center space-x-6 h-[50px]">
                                                <label className="flex items-center space-x-2 cursor-pointer group">
                                                    <div className="relative">
                                                        <input
                                                            type="radio"
                                                            name="workOption"
                                                            value="true"
                                                            checked={detectCheckBox === true}
                                                            onChange={detectCheck}
                                                            className="sr-only"
                                                        />
                                                        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${detectCheckBox === true
                                                            ? 'border-[#B93C2F] bg-[#B93C2F] shadow-lg shadow-red-500/30 scale-110'
                                                            : 'border-gray-300 bg-white group-hover:border-[#B93C2F] group-hover:scale-105'
                                                            }`}>
                                                            {detectCheckBox === true && (
                                                                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                                                </svg>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <span className={`text-sm font-semibold transition-all duration-300 ${detectCheckBox === true ? 'text-[#B93C2F]' : 'text-gray-600 group-hover:text-gray-800'
                                                        }`}>Sí</span>
                                                </label>

                                                <label className="flex items-center space-x-2 cursor-pointer group">
                                                    <div className="relative">
                                                        <input
                                                            type="radio"
                                                            name="workOption"
                                                            value="false"
                                                            checked={detectCheckBox === false}
                                                            onChange={detectCheck}
                                                            className="sr-only"
                                                        />
                                                        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${detectCheckBox === false
                                                            ? 'border-[#B93C2F] bg-[#B93C2F] shadow-lg shadow-red-500/30 scale-110'
                                                            : 'border-gray-300 bg-white group-hover:border-[#B93C2F] group-hover:scale-105'
                                                            }`}>
                                                            {detectCheckBox === false && (
                                                                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                                                </svg>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <span className={`text-sm font-semibold transition-all duration-300 ${detectCheckBox === false ? 'text-[#B93C2F]' : 'text-gray-600 group-hover:text-gray-800'
                                                        }`}>No</span>
                                                </label>
                                            </div>
                                        </div>

                                        {OnWork === false && (
                                            <div className="flex flex-col space-y-1.5">
                                                <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                                    <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                                    Fecha salida
                                                </label>
                                                <input
                                                    type="date"
                                                    name="finishDate"
                                                    {...register("finishDate", { required: !OnWork })}
                                                    id="finishDate"
                                                    className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 cursor-pointer hover:border-gray-300"
                                                />
                                                {validations.finishDate?.map((values) => (
                                                    errors.finishDate?.type === values.type &&
                                                    <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    {/* Funciones desempeñadas */}
                                    <div className="flex flex-col space-y-1.5">
                                        <label className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                                            <span className="w-1.5 h-4 bg-gradient-to-b from-[#B93C2F] to-[#D37267] rounded-full"></span>
                                            Funciones desempeñadas
                                        </label>
                                        <div className="relative group">
                                            <textarea
                                                name="functionsPerformed"
                                                id="functionsPerformed"
                                                {...register("functionsPerformed", { required: true })}
                                                rows="3"
                                                placeholder="Funciones desempeñadas"
                                                className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-2xl text-[#3C2E2C] placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#B93C2F]/10 focus:border-[#B93C2F] transition-all duration-300 hover:border-gray-300 pr-12 resize-none"
                                            />
                                            <div className="absolute right-4 top-4 text-gray-300 group-hover:text-[#B93C2F] transition-colors duration-300">
                                                <DocumentTextIcon className="h-5 w-5" />
                                            </div>
                                        </div>
                                        {validations.functionsPerformed?.map((values) => (
                                            errors.functionsPerformed?.type === values.type &&
                                            <span key={values.type} className="text-xs text-[#B93C2F] font-semibold flex items-center gap-1">✕ {values.message}</span>
                                        ))}
                                    </div>

                                    {/* Separador */}
                                    <div className="relative my-6">
                                        <div className="absolute inset-0 flex items-center">
                                            <div className="w-full border-t-2 border-gray-200/60"></div>
                                        </div>
                                        <div className="relative flex justify-center">
                                            <span className="px-4 bg-white">
                                                <span className="flex items-center gap-2 text-xs text-gray-400 font-mono">
                                                    <span className="w-4 h-0.5 bg-gradient-to-r from-[#B93C2F] to-[#D37267]"></span>
                                                    ◆
                                                    <span className="w-4 h-0.5 bg-gradient-to-l from-[#B93C2F] to-[#D37267]"></span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>

                                    {/* Botones */}
                                    <div className="flex justify-end gap-4 pt-2">
                                        <button
                                            type="button"
                                            onClick={() => { setShowModal(false); resetAllInputs(); }}
                                            className="px-8 py-3 bg-white border-2 border-gray-200 rounded-2xl text-sm font-bold text-[#D37267] hover:bg-red-50 hover:border-[#D37267] transition-all duration-300 shadow-sm hover:shadow-md"
                                        >
                                            Cancelar
                                        </button>

                                        <button
                                            type="submit"
                                            className="px-8 py-3 bg-[#006E4E] hover:bg-[#005c41] text-white rounded-2xl text-sm font-bold flex items-center gap-2 transition-all duration-300 shadow-lg shadow-emerald-800/20 hover:shadow-emerald-800/30"
                                        >
                                            <CheckCircleIcon className="h-5 w-5" />
                                            Confirmar
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </Modal>
                    )}
                </div>
            </div>
        </div>
    );
}